import type { BaseResponse } from "~/@types";
import { http } from "~/libs/axios";

export type PosActivityType = "income" | "expense";

export interface PosActivity {
  _id: string;
  id?: string;
  amount: number;
  type: PosActivityType;
  note?: string | null;
  createdAt: string;
  updatedAt: string;
}

export interface PosActivityPayload {
  amount: number; // bilangan bulat positif (divalidasi backend)
  type: PosActivityType;
  note?: string;
}

export interface PosStreak {
  current_streak: number;
  longest_streak: number;
  last_active_date: string | null; // "YYYY-MM-DD" (WIB)
  total_records: number;
}

export interface PosDailySummary {
  date: string; // "YYYY-MM-DD" (WIB)
  income: number;
  expense: number;
  net: number;
}

export interface PosSummary {
  today: PosDailySummary;
  daily: PosDailySummary[];
}

type PosActivityResponse = BaseResponse & { data: PosActivity };
type PosActivityListResponse = BaseResponse & { data: PosActivity[] };
type PosStreakResponse = BaseResponse & { data: PosStreak };
type PosSummaryResponse = BaseResponse & { data: PosSummary };

export const pos = {
  // Catat satu transaksi kas (pemasukan/pengeluaran) milik user.
  create: (payload: PosActivityPayload) => http<PosActivityResponse>("POST", { url: "/pos-activity", data: payload }),

  // Riwayat 30 catatan terakhir, terbaru lebih dulu.
  getActivities: () => http<PosActivityListResponse>("GET", { url: "/pos-activity" }),

  // Streak mencatat kas — angka dihitung backend, jangan dihitung ulang di klien.
  getStreak: () => http<PosStreakResponse>("GET", { url: "/pos-activity/streak" }),

  // Rekap kas: net hari ini + rekap harian s/d 30 hari terakhir.
  getSummary: () => http<PosSummaryResponse>("GET", { url: "/pos-activity/summary" }),
};
